import PostcodeMixin from './PostcodeMixin'

export default {
    mixins: [
        PostcodeMixin
    ]
}